// Identifiants DOM d'un onglet et de son panneau (aria-controls / aria-labelledby),
// partages par EditorTabs et l'editeur.
export const tabDomId = (id: string) => `editor-tab-${id}`;
export const panelDomId = (id: string) => `editor-panel-${id}`;
